import { DateContainer } from "./date-container"
import { WorkflowSchema } from "./workflow-schema"

export enum TaskLifecycleStates {
    FINALIZED = 'finalized',
    IN_PREPARATION = 'inPreparation',
    IN_PROGRESS = 'inProgress',
    PLANNED = 'planned',
}

export interface Task {
    id: string,
    title: string,
    taskSchema: {
        applicant: string,
        demandDate: DateContainer,
        limitDate: DateContainer,
    },
    workflowSchema: WorkflowSchema<TaskLifecycleStates>,
}